//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { TABLET, MOBILE } from '@/scripts/constants/media-query'
import { HITS_PER_PAGE_DESKTOP, ProductTypeE } from '@/scripts/constants/plp'

import { getBannersFromPage } from '../dynamic-plp-banner'
import { mapBanners } from '../dynamic-plp-banner'
import { mapProducts } from '../dynamic-plp-banner'
import { generateProductsAndBanners } from '../dynamic-plp-banner'
import RbProductTile from '@/elements/product-tile/rb-product-tile.vue'
import VRuntimeTemplate from 'v-runtime-template'
import { POSITIVE_VALUES } from '@/scripts/constants/booleans'
import { ACTION_RESET_FOCUSED_PRODUCT_TILE } from '@/scripts/store/plp/actions'
import { createNamespacedHelpers } from 'vuex'

const { mapActions: mapActionsPlp } = createNamespacedHelpers('plp')

export default {
  name: 'rb-products',
  inject: ['isPlpExclusive', 'handleWishlistModal'],
  components: {
    RbProductTile,
    VRuntimeTemplate,
  },
  props: {
    products: {
      type: Array,
      required: true,
    },
    appliedFacets: {
      type: Array,
      required: true,
    },
    isPlpExclusive: {
      type: Boolean,
      default: false,
    },
    dataElementId: {
      type: String,
      default: '',
    },
    isInsideSearchPanel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      productsAndBanners: [],
      BANNER: ProductTypeE.BANNER,
      elementInViewportSearchPanel: [],
    }
  },
  computed: {
    isMobile() {
      return this.$mq === TABLET || this.$mq === MOBILE
    },
    getNumberOfColumns() {
      if (this.isMobile) {
        return 2
      }
      return 3
    },
    productTileClass() {
      return this.isPlpExclusive ? 'col-12' : 'col-6 col-md-6 col-lg-4'
    },
  },
  watch: {
    products: {
      handler() {
        this.mergeProductsAndBanners()
      },
      immediate: true,
    },
    appliedFacets: {
      handler() {
        this.mergeProductsAndBanners()
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.isInsideSearchPanel && this.isMobile && !this.isPlpExclusive) {
      this.insidePanelObserverElement()
    }
    this.$refs?.banner?.forEach((el) => {
      el.$el?.addEventListener('focusin', this.onBannerFocus)
    })
  },
  beforeDestroy() {
    this.$refs?.banner?.forEach((el) => {
      el.$el?.removeEventListener('focusin', this.onBannerFocus)
    })
  },
  methods: {
    ...mapActionsPlp({
      resetFocusedTileId: ACTION_RESET_FOCUSED_PRODUCT_TILE,
    }),
    isTileInViewPortSearch(elementId) {
      return this.elementInViewportSearchPanel.includes(elementId)
    },
    hasPreventLazy(i) {
      return i <= 3
    },
    onBannerFocus() {
      this.resetFocusedTileId()
    },
    setDataElementId(index) {
      return `${this.dataElementId}_Tile${index}`
    },
    mergeProductsAndBanners() {
      const bannersFromPage = getBannersFromPage()
      const banners = mapBanners(bannersFromPage).filter((banner) => {
        return this.appliedFacets.length === 0 || POSITIVE_VALUES.includes(banner.visibleOnFilter)
      })
      const products = mapProducts(this.products)
      const numberOfColumns = this.getNumberOfColumns
      this.productsAndBanners = generateProductsAndBanners({
        products,
        banners,
        numberOfColumns,
      })
    },
    getBannerColumn(banner) {
      const size = banner.size
      if (size === 1) {
        return 'col-6 col-lg-4'
      } else if (size === 2) {
        return 'col-12 col-lg-8'
      } else if (size === 3) {
        return 'col-12'
      }
    },
    focusFirstNewTileAfterLoadMore(pageNumber) {
      const indexOfFirstNewTile = (pageNumber - 1) * HITS_PER_PAGE_DESKTOP
      const firstNewTile = this.$refs.tile[indexOfFirstNewTile].$el
      firstNewTile.focus()
    },
    insidePanelObserverElement() {
      const rbSearch = document.querySelector('.rb-search')
      const inRbSearch = document.querySelector('.--is-in-search')
      const tileWrapper = document.querySelectorAll('.rb-product-tile__wrapper')
      rbSearch.addEventListener(
        'scroll',
        (scroll) => {
          const options = {
            root: inRbSearch,
            rootMargin: '0px',
            threshold: 1.0,
          }
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const { elementId } = entry.target.dataset
                if (
                  entry.intersectionRect.top > 0 &&
                  entry.intersectionRect.top <= scroll.target.offsetHeight
                ) {
                  if (!this.elementInViewportSearchPanel.includes(elementId)) {
                    this.elementInViewportSearchPanel.push(elementId)
                  }
                } else {
                  const findIndexElement = this.elementInViewportSearchPanel.findIndex(
                    (el) => el === elementId
                  )
                  if (findIndexElement !== -1) {
                    this.elementInViewportSearchPanel.splice(findIndexElement, 1)
                  }
                }
              }
            })
          }, options)
          tileWrapper.forEach((e) => {
            observer.observe(e)
          })
        },
        {
          passive: true,
        }
      )
    },
  },
}
